import Page from "../Page/Page";
import "../../Styles/hisstoriPlus.css";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { Transaction_PlusExams } from "../../Connections/Transaction";
import { useState } from "react";

const HisstoriPlus = () => {
  const navigate = useNavigate();
  const [numberOfExams, setNumberOfExams] = useState({
    plusExam: 0,
    tvExam: 0,
  });

  //get number of exam user
  useEffect(() => {
    Transaction_PlusExams.GetNumberOfUser()
      .then((res) => {
        if (res[0]) {
          setNumberOfExams(res[2].data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Page>
      {/* header background */}
      <div className="wrapper_hisstoriPlus">
        <img
          className="header-bg-stars mobile-hidden"
          src={
            "https://ketabno.com/static/media/first-section-background.5913a5be96843bbb494e.svg"
          }
          alt="bg"
        />
        <img
          className="desktop-hidden header-star-mobile"
          src={"/imgs/ambassadors/1000000952.svg"}
          alt="bg"
        />
        <section className="hisstori-plus-section-top">
          <div className="header-banners">
            <div className="parent-book-banner">
              <img
                className="book-banner"
                src="/imgs/hisstoriPlus/plus-banner-index.svg"
                alt="bookImg"
              />
            </div>
            <div className="left-description-box">
              <div className="parent-svg-plus">
                <img src="/imgs/hisstoriPlus/plus-svg.svg" alt="plus" />
              </div>
              <p className="mobile-hidden">
                تو هیس‌طوری پلاس یه عالمه راه جدید هست برای اینکه بتونی کلیییی
                امتیاز بگیری! بزن بریم :)
              </p>
            </div>
          </div>
        </section>
        <section className="hisstori-plus-card-section">
          {/* card one  */}
          <div className="competition-card">
            <div className="banner-card-parent">
              <img
                className="banner-card-img"
                src="/imgs/hisstoriPlus/savad-hisstori.svg"
                alt="savad-svg"
              />
            </div>
            <h2 className="competition-card-title">مسابقه سواد هیس‌طوری</h2>
            <p>
              سواد هیس‌طوری، یه مسابقه‌ی سخت و ویژه‌ست برای اونایی که همه‌ی
              کتاب‌های سرگذشت استعمار رو قورت دادن :)
            </p>
            <div
              className="copetition-card-btn-box"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="copetition-card-btn">
                <img src="/imgs/hisstoriPlus/test-icon.svg" alt="test-icon" />
                <span>۱۵ آزمون ۱۵ سوالی</span>
              </div>
              <div className="copetition-card-btn">
                <img src="/imgs/bashgah/bashgah-group.svg" alt="diamond-icon" />
                <span>مجموعا ۷۸۰۰ امتیاز</span>
              </div>
            </div>
            {/* <div className="parent-bottom-box-btns" style={{ display: "flex" }}>
              <div className="copetition-card-btn-lock">
                <span>منتظر باشین، این مسابقه به زودی شروع می‌شه :)</span>
                <img src="/imgs/hisstoriPlus/lock-icon.svg" alt="unlock-icon" />
              </div>
            </div> */}
            <div className="parent-bottom-box-btns" style={{ display: "flex" }}>
              <div className="copetition-card-btn-two-parts">
                <div className="left-side-btn">
                  {numberOfExams.plusExam} شرکت کننده{" "}
                </div>
              </div>
              <div
                onClick={() => navigate("/hisstori/knowledge")}
                className="copetition-card-btn-unlock"
              >
                <span>همین الان شروع کن</span>
                <img
                  src="/imgs/hisstoriPlus/unlock-icon.svg"
                  alt="unlock-icon"
                />
              </div>
            </div>
          </div>
          {/* card two  */}
          <div
            style={{ backgroundColor: "#061A55" }}
            className="competition-card"
          >
            <div className="banner-card-parent">
              <img
                className="banner-card-img-2"
                src="/imgs/hisstoriPlus/tv-hisstori.svg"
                alt="savad-svg"
              />
            </div>
            <h2 className="competition-card-title">
              مسابقه تلویزیونی هیس‌طوری
            </h2>
            <p>
              برای شرکت توی این مسابقه، باید پای ثابت برنامه‌ی تلویزیونی
              هیس‌طوری باشی، این برنامه رو ببین و بیا توی آزمون شرکت کن...
            </p>
            <div
              className="copetition-card-btn-box"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="copetition-card-btn">
                <img src="/imgs/hisstoriPlus/test-icon.svg" alt="test-icon" />
                <span>۵۰ آزمون ۵ سوالی</span>
              </div>
              <div className="copetition-card-btn">
                <img src="/imgs/bashgah/bashgah-group.svg" alt="diamond-icon" />
                <span>مجموعا ۵۰۰۰ امتیاز</span>
              </div>
            </div>
            <div className="parent-bottom-box-btns" style={{ display: "flex" }}>
              <div className="copetition-card-btn-two-parts">
                <div className="left-side-btn">
                  {numberOfExams.tvExam} شرکت کننده{" "}
                </div>
              </div>
              <div
                onClick={() => navigate("/hisstori/tv-plus")}
                className="copetition-card-btn-unlock"
              >
                <span>همین الان شروع کن</span>
                <img
                  src="/imgs/hisstoriPlus/unlock-icon.svg"
                  alt="unlock-icon"
                />
              </div>
            </div>
            {/* <div className="parent-bottom-box-btns" style={{ display: "flex" }}>
              <div className="copetition-card-btn-lock">
                <span>منتظر باشین، این مسابقه به زودی شروع می‌شه :)</span>
                <img src="/imgs/hisstoriPlus/lock-icon.svg" alt="unlock-icon" />
              </div>
            </div> */}
          </div>
        </section>
      </div>
    </Page>
  );
};

export default HisstoriPlus;
